var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "logo-wrap" }, [
      _c("div", [_c("img", { attrs: { src: _vm.logo, alt: "" } })]),
      _c("div", { staticClass: "line" }),
      _c("div", [
        _c("span", [
          _vm._v(_vm._s(_vm.config.registeredServiceName || "统一身份认证"))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }